import { render, staticRenderFns } from "./realName.vue?vue&type=template&id=61e3d840&"
import script from "./realName.vue?vue&type=script&lang=js&"
export * from "./realName.vue?vue&type=script&lang=js&"
import style0 from "./realName.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports